import { render, staticRenderFns } from "./CandidateNote.html?vue&type=template&id=c42759b0&scoped=true&external"
import script from "./CandidateNote.js?vue&type=script&lang=js&external"
export * from "./CandidateNote.js?vue&type=script&lang=js&external"
import style0 from "./CandidateNote.scss?vue&type=style&index=0&id=c42759b0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42759b0",
  null
  
)

export default component.exports